import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

const LINKS = [
  {
    href: '/blog/automatically-rename-pdfs-by-content',
    title: 'Automatically rename PDFs by content',
    desc: 'The pattern Sortio uses for vendor invoices, lease packets, and maintenance reports.',
  },
  {
    href: '/for-real-estate',
    title: 'Sortio for real estate',
    desc: 'For the brokerage side of the business. Per-property transaction folders, dotloop integration.',
  },
  {
    href: '/for-accountants',
    title: 'Sortio for accountants',
    desc: 'Year-end 1099-NEC prep for your vendors, owner statements for CPAs, multi-entity routing.',
  },
  {
    href: '/blog/local-ai-vs-cloud-ai-file-organization',
    title: 'Local AI vs cloud AI',
    desc: 'What stays on your Mac in each mode. Important for tenant SSNs on screening reports.',
  },
  {
    href: '/blog/ai-sort-vs-rule-builder-which-to-use',
    title: 'AI Sort vs Rule Builder',
    desc: 'A new month\'s pile is an AI Sort job. A historical archive of 50,000 maintenance reports is a Rule Builder job.',
  },
  {
    href: '/integrations',
    title: 'All Sortio integrations',
    desc: 'Buildium, Rent Manager, dotloop, Zotero, Clio, plus Raycast and Apple Shortcuts.',
  },
];

const RelatedReading = () => {
  return (
    <section id="related" className="my-20">
      <div className="text-center mb-12">
        <div className="inline-block mb-4">
          <div className="flex items-center justify-center px-4 py-1.5 rounded-full bg-sortio-primary/10 border border-sortio-primary/20">
            <BookOpen className="mr-2 text-sortio-primary" size={14} />
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">Related reading</span>
          </div>
        </div>
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          More for property management
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
        {LINKS.map((link, i) => (
          <Link key={i} to={link.href} className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 hover:border-sortio-primary/40 transition-all group">
            <h3 className="text-base font-medium text-apple-50 mb-2 group-hover:text-sortio-primary transition-colors flex items-start">
              <span className="flex-1">{link.title}</span>
              <ArrowRight className="ml-2 flex-shrink-0 mt-1 text-apple-400 group-hover:text-sortio-primary group-hover:translate-x-1 transition-all" size={14} />
            </h3>
            <p className="text-sm text-apple-300 leading-relaxed">{link.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedReading;
